<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Mapping Program Study - Jurusan
      </CCardHeader>
      <CCardBody>
        <div class="form-group" v-bind:class="{ error: errors.major_id }">
          <label>Jalur masuk</label>
          <entrance-major v-model="data.entrance_major" />
          <message-container :data="errors.major_id" />
        </div>
        <div
          class="form-group"
          v-bind:class="{ error: errors.study_program_group_id }"
        >
          <label>Group</label>
          <study-program-group-selector v-model="data.study_program_group" />
          <message-container :data="errors.study_program_group_id" />
        </div>
        <div
          class="form-group"
          v-bind:class="{ error: errors.study_program_id }"
        >
          <label>Program Study</label>
          <study-program-selector v-model="data.study_program" />
          <message-container :data="errors.study_program_id" />
        </div>
        <div class="form-group" v-bind:class="{ error: errors.year }">
          <label>Tahun</label>
          <year-selector v-model="data.year" />
          <message-container :data="errors.year" />
        </div>
        <div class="form-group" v-bind:class="{ error: errors.registrar }">
          <label>Jumlah Pendaftar</label>
          <input type="number" class="form-control" v-model="data.registrar" />
          <message-container :data="errors.registrar" />
        </div>
        <div class="form-group" v-bind:class="{ error: errors.tightness }">
          <label>Jumlah Keketatan</label>
          <input type="number" class="form-control" v-model="data.tightness" />
          <message-container :data="errors.tightness" />
        </div>
        <div class="form-group" v-bind:class="{ error: errors.capacity }">
          <label>Daya Tampung</label>
          <input type="number" class="form-control" v-model="data.capacity" />
          <message-container :data="errors.capacity" />
        </div>
        <div class="form-group" v-bind:class="{ error: errors.national_value }">
          <label>Nilai Nasional</label>
          <input
            type="number"
            class="form-control"
            v-model="data.national_value"
          />
          <message-container :data="errors.national_value" />
        </div>
      </CCardBody>
      <CCardFooter>
        <btn-save-update
          :data="data"
          @save="save"
          @update="update"
          @back="goBack"
        />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import BtnSaveUpdate from "../../components/BtnSaveUpdate";
import MajorSelector from "../../components/MajorSelector";
import StudyProgramSelector from "../../components/StudyProgramSelector";
import StudyProgramGroupSelector from "../../components/StudyProgramGroupSelector";
import YearSelector from "../../components/YearSelector";
import MessageContainer from "../../components/MessageContainer";
import EntranceMajor from "../../components/EntranceMajor";
import { showErrorMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  data() {
    return {
      data: {},
      errors: [],
    };
  },
  components: {
    MajorSelector,
    StudyProgramSelector,
    StudyProgramGroupSelector,
    YearSelector,
    MessageContainer,
    BtnSaveUpdate,
    EntranceMajor,
  },
  created() {
    const query = this.$route.params;
    if (query && query.id) {
      this.get(query.id);
    }
  },
  methods: {
    get(id) {
      if (id == "new") {
        return;
      }
      HTTPAUTH.get(`/api/v1/admin/mapping/study/${id}`, this.data)
        .then((res) => {
          this.data = res.data.data;
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    save() {
      if (this.data.major) {
        this.data.major_id = this.data.major.id;
        // this.data.major = null
      }
      if (this.data.study_program) {
        this.data.study_program_id = this.data.study_program.id;
        // this.data.study_program = null
      }
      if (this.data.study_program_group) {
        this.data.study_program_group_id = this.data.study_program_group.id;
        // this.data.study_program = null
      }
      if (!(this.data && this.data.year)) {
        this.$toasted.error("Pilih tahun terlebih dahulu").goAway();
        return;
      }
      HTTPAUTH.post(`/api/v1/admin/mapping/study`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil disimpan").goAway();
        })
        .catch((eres) => {
          this.errors = showErrorMessage(eres);
        });
    },
    update() {
      if (this.data.major) {
        this.data.major_id = this.data.major.id;
        // this.data.major = null
      }
      if (this.data.study_program) {
        this.data.study_program_id = this.data.study_program.id;
        // this.data.study_program = null
      }
      if (this.data.study_program_group) {
        this.data.study_program_group_id = this.data.study_program_group.id;
        // this.data.study_program = null
      }
      if (!(this.data && this.data.year)) {
        this.$toasted.error("Pilih tahun terlebih dahulu").goAway();
        return;
      }
      HTTPAUTH.put(`/api/v1/admin/mapping/study/${this.data.id}`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil disimpan").goAway();
        })
        .catch((eres) => {
          this.errors = showErrorMessage(eres);
        });
    },
    goBack() {
      this.$router.push({ path: "/mapping/study-program/major" });
    },
  },
};
</script>